import { AddUserCard } from "../components/AddUserCard";
import { TopAdminNav } from "../layouts/TopAdminNav";
export interface ISubject {
  id: string;
  school_id: string;
  name: string;
  code: string;
  description: string;
  created_at: string;
  updated_at: string;
}
const Subject = () => {
  return (
    <>
      <div className="w-full">
        <TopAdminNav name="Jane Doe" title="Subject Management" />
      </div>

      <div className="flex flex-wrap items-center pt-4">
        <AddUserCard
          title="View all Subjects"
          content="Create/edit new subject"
          link="/admin/subject/register-subject"
        />
        {/* <AddUserCard
          title="Activity Planner"
          content="View all activities"
          link="/admin/staff/lesson_note"
        /> */}

        <AddUserCard
          title="Add Class Subject"
          content="View/add subject to class"
          link="/admin/subject/register-class-subject"
        />
      </div>
    </>
  );
};

export default Subject;
